var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiveFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "detail-panel",
    transform: "translate(-16.000000, -873.000000)",
    fill: "#0091EA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "give-feedback",
    transform: "translate(16.000000, 870.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3808128,3 L1.1428474,3 C0.51167021,3 0,3.51167021 0,4.1428474 L0,14.4680927 C0.00213499654,14.7669464 0.124518376,15.0523517 0.339539422,15.2599187 C0.554560468,15.4674857 0.844104299,15.5797275 1.1428474,15.5713214 L3.4285422,15.5713214 L3.4285422,18.6189145 C3.42849182,18.7606966 3.50718495,18.8907763 3.63279251,18.9565403 C3.75840008,19.0223042 3.91013786,19.0128705 4.02663235,18.9320547 L8.88068621,15.5713214 L16.3808128,15.5713214 C17.0119899,15.5713214 17.5236602,15.0596512 17.5236602,14.428474 L17.5236602,4.1428474 C17.5236602,3.51167021 17.0119899,3 16.3808128,3 Z M3.61901677,10.9999318 C3.61901677,10.6843432 3.87485188,10.4285081 4.19044047,10.4285081 L13.3332197,10.4285081 C13.6488083,10.4285081 13.9046434,10.6843432 13.9046434,10.9999318 C13.9046434,11.3155204 13.6488083,11.5713555 13.3332197,11.5713555 L4.19044047,11.5713555 C3.87485188,11.5713555 3.61901677,11.3155204 3.61901677,10.9999318 Z M13.3332197,8.14281331 L4.19044047,8.14281331 C3.87485188,8.14281331 3.61901677,7.8869782 3.61901677,7.57138961 C3.61901677,7.25580101 3.87485188,6.99996591 4.19044047,6.99996591 L13.3332197,6.99996591 C13.6488083,6.99996591 13.9046434,7.25580101 13.9046434,7.57138961 C13.9046434,7.8869782 13.6488083,8.14281331 13.3332197,8.14281331 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveFeedback);
export default __webpack_public_path__ + "static/media/giveFeedback.520d49d381362f3182d4cc19b726a871.svg";
export { ForwardRef as ReactComponent };